// src/utils/md5.js
import CryptoJS from 'crypto-js';

export function md5Encrypt(text) {
  return CryptoJS.MD5(text).toString().toUpperCase();
}